import { makeStyles } from "@material-ui/core";
import { useRecoilValue } from "recoil";
import FlightPathModeState from "../../../store/FlightPathModeState";
import { weatherTimeWithID, WX_ID_ACOS } from "../../../store/WeatherContentsState";

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection:'column',
    flexWrap:'wrap',
    justifyContent: 'flex-start',
    marginBottom: '3px'
  },
  columnBox: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  item: {
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px',
    display: 'flex',
    alignItems: 'center'
  },
  label: {
    display: "inline-block",
    textAlign: 'left',
    paddingLeft: '5px',
    whiteSpace: "nowrap",
    fontSize: 12
  },
  legendBase: {
    display: "inline-block",
    height: 10,
    width: 30,
    border: 'solid 2px'
  },
  ft03: {
    backgroundColor: "rgba(220, 107, 44, 0.5)",
    borderColor: "rgba(220, 107, 44, 1.0)"
  },
  ft06: {
    backgroundColor: "rgba(234, 100, 255, 0.5)",
    borderColor: "rgba(234, 100, 255, 1.0)"
  },
  ft09: {
    backgroundColor: "rgba(76, 158, 8, 0.5)",
    borderColor: "rgba(76, 158, 8, 1.0)"
  },
  ft12: {
    backgroundColor: "rgba(255, 255, 0, 0.5)",
    borderColor: "rgba(255, 255, 0, 1.0)"
  },
  ft15: {
    backgroundColor: "rgba(73, 221, 194, 0.5)",
    borderColor: "rgba(73, 221, 194, 1.0)"
  },
  ft18: {
    backgroundColor: "rgba(35, 110, 241, 0.5)",
    borderColor: "rgba(35, 110, 241, 1.0)"
  },
  ft21: {
    backgroundColor: "rgba(197, 78, 160, 0.5)",
    borderColor: "rgba(197, 78, 160, 1.0)"
  },
  ft24: {
    backgroundColor: "rgba(106, 55, 167, 0.5)",
    borderColor: "rgba(106, 55, 167, 1.0)"
  },
}));

function LegendACOS() {
  const classes = useStyles();
  const time = useRecoilValue(weatherTimeWithID(WX_ID_ACOS));
  const fpMode = useRecoilValue(FlightPathModeState);

  return (
    <div>
      <div className="legend-contents-time cross-legend-contents-time">
        {fpMode ? "" : time.validTime}
      </div>
      <div className={classes.box}>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft03}`}></span><span className={classes.label}>FT03H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft06}`}></span><span className={classes.label}>FT06H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft09}`}></span><span className={classes.label}>FT09H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft12}`}></span><span className={classes.label}>FT12H</span>
          </li>
        </ul>
        <ul className={classes.columnBox}>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft15}`}></span><span className={classes.label}>FT15H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft18}`}></span><span className={classes.label}>FT18H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft21}`}></span><span className={classes.label}>FT21H</span>
          </li>
          <li className={classes.item}>
            <span className={`${classes.legendBase} ${classes.ft24}`}></span><span className={classes.label}>FT24H</span>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default LegendACOS;
